import { render, staticRenderFns } from "./customTree.vue?vue&type=template&id=4e090163&"
import script from "./customTree.vue?vue&type=script&lang=js&"
export * from "./customTree.vue?vue&type=script&lang=js&"
import style0 from "./customTree.vue?vue&type=style&index=0&id=4e090163&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports